/**
 * After Sales Service 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Provider account connection request DTO
 */
export interface ConnectProviderRequestDTO { 
    /**
     * Provider code (eg., VTP, GHN)
     */
    providerCode: ConnectProviderRequestDTO.ProviderCodeEnum;
    /**
     * Account code (eg., VTP-001, GHN-A)
     */
    code?: string;
    /**
     * Account name (eg., VTP Account 01, Giao Hang Nhanh Acc A)
     */
    name?: string;
    /**
     * Notes, remarks, infor,...
     */
    description?: string;
    /**
     * Status (ACTIVE | INACTIVE)
     */
    status?: string;
    /**
     * Whether be the default account of the provider
     */
    isDefault?: boolean;
    /**
     * Connect information (eg., username, password, API token, shop ID)
     */
    connectInfo?: { [key: string]: object; };
}
export namespace ConnectProviderRequestDTO {
    export const ProviderCodeEnum = {
        Vtp: 'VTP',
        Ghn: 'GHN'
    } as const;
    export type ProviderCodeEnum = typeof ProviderCodeEnum[keyof typeof ProviderCodeEnum];
}


